import { render, staticRenderFns } from "./SeverityBehavior.vue?vue&type=template&id=3fce0652&scoped=true&"
import script from "./SeverityBehavior.vue?vue&type=script&lang=js&"
export * from "./SeverityBehavior.vue?vue&type=script&lang=js&"
import style0 from "./SeverityBehavior.vue?vue&type=style&index=0&id=3fce0652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce0652",
  null
  
)

export default component.exports